import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { DcrType } from '@/core/graphql/generated/types';

import { formatDiffingValue } from '../../_utils/formatDiffingValue';

import { reviewRowStyles as sx } from './ReviewRow.styles';

type ReviewRowProps = {
	labelKey: string;
	oldVal: unknown;
	newVal: unknown;
	fieldTranslations: Record<string, string> | undefined;
	dcrType: DcrType;
};

export const ReviewRow = ({
	labelKey,
	oldVal,
	newVal,
	fieldTranslations,
	dcrType
}: ReviewRowProps) => {
	const { t } = useTranslation();

	const displayLabel =
		labelKey === 'id'
			? '' // Placeholder
			: (fieldTranslations?.[labelKey] ?? t(labelKey));

	return (
		<Box sx={sx.row}>
			<Typography sx={sx.fieldLabel}>{displayLabel}</Typography>
			{dcrType === DcrType.Change && (
				<Typography sx={sx.fieldValueOld}>
					{formatDiffingValue(oldVal)}
				</Typography>
			)}
			<Typography sx={sx.fieldValueNew}>
				{formatDiffingValue(newVal)}
			</Typography>
		</Box>
	);
};
